import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../components/SeoHead";
import { Container } from "reactstrap";
import MainBanner from "../../components/MainBanner";
import MultiColumnCTAWithDivider from "../../components/MultiColumnCTAWithDivider";
import ThemeAFocusValuesSlider from "../../components/ThemeAFocusValuesSlider";
import ThemeAMultiColumnCTA from "../../components/ThemeAMultiColumnCTA";
import ThemeAImageWithText from "../../components/ThemeAImageWithText";
import LatestNews from "../../components/LatestNews";
import NewColumnWithForm from "../../components/NewColumnWithForm";

export default function AboutUs({
  global,
  all_about_us_focus_values,
  all_news,
  all_about_us_image_with_text,
}) {
  return (
    <>
      <SeoHead
        page_name={`About Lorien | Technology Recruitment Experts`}
        description={`Learn about Lorien's mission, values, and expertise in delivering high-quality recruitment and workforce solutions across the Technology sector.`}
        canonical_link={`about-us`}
      />
      <MainBanner
        global={global}
        pathPrefix={`about_us_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>About Us</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/sub-banner-about-us.png`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        editableContent={true}
        breadcrumb_title="About Us"
      />
      <ThemeAFocusValuesSlider
        global={global}
        pathPrefix={`about_us_page.theme_a_focus_values_slider`}
        customClass={`pt-5 pb-4 primary-bg text-center`}
        post={all_about_us_focus_values}
        swiperID={`aboutFocusValuesSwiper`}
      />
      <ThemeAImageWithText
        global={global}
        pathPrefix={`about_us_page.image_with_text`}
        customClass={`py-5 bg-gradient`}
        post={all_about_us_image_with_text}
        videoGalleryClass={`about`}
        buttonLink={``}
        buttonTitle={``}
        primaryBtn={true}
      />
      <LatestNews
        global={global}
        pathPrefix={`business_solutions_page.latest_news`}
        customClass={`py-5`}
        post={all_news}
        content={
          <>
            <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
            <p>
              Our tech expertise and partner-led approach allows us to deliver
              highly successful results for our clients so they can attract and
              retain unique talent for their business. Explore our latest
              collection of case studies, news, events, and insights
            </p>
          </>
        }
        buttonLink={`/insights/`}
        buttonTitle={`View All Insights`}
      />
      <Container>
        <hr></hr>
      </Container>
      <ThemeAMultiColumnCTA
        global={global}
        pathPrefix={`about_us_page.theme_a_multicolumn_cta`}
        customClass={`py-5`}
        content={
          <>
            <h2>Life at Lorien</h2>
          </>
        }
        left_content={
          <>
            <h3>Join #TeamLorien</h3>
            <p>
              People. Lead. Growth. Three simple words. That’s the secret to our
              people-centric approach.
            </p>
          </>
        }
        buttonLink_left={`/about-us/join-us`}
        buttonTitle_left={`Join Lorien`}
        imageALT={`Life at Lorien`}
        post={all_news}
        swiperID={`lifeatlorien`}
      />
      <NewColumnWithForm 
                formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
                successPageUrl={`/about-us/join-us/submission-success`}
            />
      {/* <MultiColumnCTAWithDivider
        global={global}
        pathPrefix={`meet_the_team_page.multi_column_cta`}
        customClass={`pt-5 pb-md-4 pb-5`}
        left_content={
          <>
            <h2>Get in Touch</h2>
          </>
        }
        right_content={
          <>
            <h2>Work for us</h2>
          </>
        }
        buttonLink2={`/about-us/csr-and-partnerships`}
        buttonLink1={`/contact-us`}
        buttonTitle1={`Contact us`}
        buttonTitle2={`Join us now`}
      /> */}
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const about_us_focus_values = await Collection("about_us_focus_values");
  const about_us_image_with_text = await Collection("about_us_image_with_text");
  const news = (await Collection("news")).filter(function (post) {
    return post.country?.en == "United Kingdom" || post.country?.en == "All";
  });

  const all_about_us_focus_values = about_us_focus_values
    .orderBy("_order")
    .getItems();
  const all_about_us_image_with_text = about_us_image_with_text
    .orderBy("_order")
    .getItems();
  const all_news = news.orderBy("_order").getItems().slice(0, 3);

  return {
    props: {
      global,
      all_about_us_focus_values,
      all_news,
      all_about_us_image_with_text,
    },
  };
}
